import {
  Grid,
} from '@oliasoft-open-source/react-ui-library';
import { getDashboardAnalytics, getNumberOfVisibleResults } from 'client/store/entities/analytics/selectors';
import { IAnalytic } from 'common/interfaces/analytics';
import {
  useSelector,
} from 'react-redux';
import { AnalyticsCard } from './analytic-card';
import { AddAnalyticsCard } from './new-analytics-card';

type TAnalyticsCardsProps = {
  onOpenDeleteModal: (item: IAnalytic) => void;
  onOpenEditModal: (item: IAnalytic) => void;
  onOpenCreateModal: () => void;
};

const AnalyticsCards = ({
  onOpenDeleteModal,
  onOpenEditModal,
  onOpenCreateModal,
}: TAnalyticsCardsProps) => {
  const analytics = useSelector(getDashboardAnalytics);
  const numberOfVisibleResults = useSelector(state => getNumberOfVisibleResults(state, analytics.map(i => i.analyticid)));
  const gridStyle = numberOfVisibleResults > 1 ? '1fr 1fr' : '1fr 1fr 1fr';

  return (
    <Grid columns={gridStyle} gap="20px">
      {analytics.map(analytic => {
        return (
          <AnalyticsCard
            onRemove={onOpenDeleteModal}
            onEdit={onOpenEditModal}
            analytic={analytic}
            key={analytic.analyticid}
          />
        );
      })}
      <AddAnalyticsCard onOpenModal={onOpenCreateModal} />
    </Grid>
  );
};

export { AnalyticsCards };
